__turbopack_context__.v({
  "closeButton": "NativeVideo-module-scss-module__O9BtSq__closeButton",
  "modal": "NativeVideo-module-scss-module__O9BtSq__modal",
  "modalContainer": "NativeVideo-module-scss-module__O9BtSq__modalContainer",
  "modalVideoWrapper": "NativeVideo-module-scss-module__O9BtSq__modalVideoWrapper",
  "overlay": "NativeVideo-module-scss-module__O9BtSq__overlay",
  "playButton": "NativeVideo-module-scss-module__O9BtSq__playButton",
  "playButtonIcon": "NativeVideo-module-scss-module__O9BtSq__playButtonIcon",
  "root": "NativeVideo-module-scss-module__O9BtSq__root",
});
